// src/services/authService.js
const API_BASE = '/api';

export const authService = {
  // Sign up with email
  async signup(fullName, email, password) {
    const response = await fetch(`${API_BASE}/auth-signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fullName, email, password, preferredLanguage: 'en' })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Signup failed');
    }
    
    return data;
  },

  // Login with email
  async login(email, password) {
    const response = await fetch(`${API_BASE}/auth-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }
    
    return data;
  },

  // Initiate Google Sign-In
  async googleSignIn() {
    window.location.href = '/api/auth-google';
  },

  // Get fresh profile from DB
  async getProfile(token) {
    const response = await fetch(`${API_BASE}/get-profile`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to fetch profile');
    return data;
  },

  // Update profile
  async updateProfile(token, profileData) {
    const response = await fetch(`${API_BASE}/update-profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(profileData)
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Profile update failed');
    }
    
    return data;
  },

  // Change password
  async changePassword(token, currentPassword, newPassword) {
    const response = await fetch(`${API_BASE}/change-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ currentPassword, newPassword })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Password change failed');
    }
    
    return data;
  },

  // Delete account
  async deleteAccount(token) {
    const response = await fetch(`${API_BASE}/delete-account`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Account deletion failed');
    }
    
    return data;
  },

  // Save token and user to localStorage
  saveAuth(token, user) {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  // Get token from localStorage
  getToken() {
    return localStorage.getItem('token');
  },

  // Get user from localStorage
  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Check if authenticated
  isAuthenticated() {
    return !!this.getToken();
  },

  // Logout
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};
